import itgrundschutz from "@/assets/images/landing-page/itgrundschutz.jpg";
import dekra from "@/assets/images/landing-page/dekra.jpg";
import cyberrisikocheck from "@/assets/images/landing-page/cyberrisikocheck.jpg";
import security from "@/assets/images/landing-page/security.jpg";

const logos = [
	{
		src: itgrundschutz,
		alt: "BSI IT-Grundschutz",
		width: 220,
		height: 100,
	},
	{
		src: dekra,
		alt: "DEKRA",
		width: 110,
		height: 100,
	},
	{
		src: cyberrisikocheck,
		alt: "CyberRisikoCheck",
		width: 123,
		height: 100,
	},
	{
		src: security,
		alt: "IT-Sicherheit",
		width: 285,
		height: 100,
	},
];

interface Props {
	className?: string;
}

export default function LandingCertificationLogos({ className }: Props) {
	return (
		<div className={className ?? "md:absolute left-0 bottom-0 w-[100vw] bg-white mx-[-32px] md:mx-[-24px] lg:mx-[-32px] border-y-[2px] border-[#E6E6EC] bottom-[3rem] sm:bottom-[7rem] flex flex-col sm:flex-row items-center justify-center opacity-90"}>
			{logos.map((logo, idx) => {
				const isLast = idx === logos.length - 1;
				const borderClass = isLast
					? ""
					: "border-b-[2px] sm:border-b-0 sm:border-r-[2px] border-[#E6E6EC]";

				return (
					<div
						key={idx}
						className={`
                            w-full sm:w-[235px]
                            h-[120px] sm:h-[180px]
                            p-[10px] 
                            flex items-center justify-center 
                            ${borderClass}
                        `}
					>
						<div className="flex items-center justify-center h-full p-4">
							<img
								alt={logo.alt}
								className="opacity-50 object-contain"
								src={logo.src}
								style={{
									width: `${logo.width}px`,
									height: `${logo.height}px`,
								}}
							/>
						</div>
					</div>
				);
			})}
		</div>
	);
}
